import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { fetchBillingSettings } from '../utils/billing';

function BillingSettings() {
  const [settings, setSettings] = useState({});
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchBillingSettings()
      .then(setSettings)
      .catch((requestError) => setError(requestError.message || 'Unable to load billing settings.'));
  }, []);
  const update = (field, value) => setSettings((current) => ({ ...current, [field]: value }));
  const save = async (event) => {
    event.preventDefault();
    try {
      setSaving(true);
      setError('');
      setMessage('');
      const response = await apiFetch('/api/invoices/settings', { method: 'PUT', body: settings });
      setSettings(response?.data || settings);
      setMessage('Billing settings saved.');
    } catch (requestError) {
      setError(requestError.message || 'Unable to save billing settings.');
    } finally {
      setSaving(false);
    }
  };
  const fields = [['businessName', 'Business Name'], ['businessAddress', 'Business Address'], ['state', 'State'], ['city', 'City'], ['pincode', 'Pincode'], ['pan', 'PAN'], ['gstin', 'GSTIN'], ['mobile', 'Mobile'], ['email', 'Email'], ['bankName', 'Bank Name'], ['accountNumber', 'Account Number'], ['ifsc', 'IFSC'], ['defaultGstRate', 'Default GST Rate'], ['defaultHsnSac', 'Default HSN/SAC'], ['invoicePrefix', 'Invoice Prefix'], ['startingNumber', 'Starting Number']];
  return <div className="billing-page"><div className="billing-page-header"><div><p className="eyebrow">Billing</p><h1>Billing Settings</h1><p className="muted">Defaults are applied to new invoices and remain editable before issue.</p></div><Link className="btn-secondary" to="/billing">Back to Billing</Link></div>{error ? <div className="billing-error">{error}</div> : null}{message ? <div className="billing-success">{message}</div> : null}<form className="billing-panel form-section" onSubmit={save}><div className="form-grid">{fields.map(([field, label]) => <label className={`field ${field === 'businessName' || field === 'businessAddress' ? 'wide' : ''}`} key={field}>{label}<input type={field === 'defaultGstRate' || field === 'startingNumber' ? 'number' : field === 'email' ? 'email' : 'text'} value={settings[field] ?? ''} onChange={(event) => update(field, event.target.value)} /></label>)}<label className="field wide">Default Terms &amp; Conditions<textarea rows="6" value={settings.defaultTerms || ''} onChange={(event) => update('defaultTerms', event.target.value)} /></label></div><div className="form-actions"><button className="btn-primary" type="submit" disabled={saving}>{saving ? 'Saving...' : 'Save Billing Settings'}</button></div></form></div>;
}

export default BillingSettings;